







import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';
@Component({
  components: { AdminIframe, PageTitle },
})
export default class OrderHoldByReservationIframe extends Vue {
  private get remoteSrc() {
    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/fulfillment/order/advance-orders?serviceType=PREMIUM';
  }
}
